import React, { useState } from "react";
import { Row, Col, Card, CardHeader, CardBody } from "reactstrap";
import MultiSearchPanel from "../../components/Search/MultiSearchPanel";
import { useIntl, FormattedMessage } from "react-intl";
import { useService } from "../../context/ServiceContext";
import SearchWizard from "../../components/Search/SearchWizard";
import useHistoryState from "../../utils/useHistoryState";
const ProductSearch = ({ onSeriesSelect, seriesSelectText, onETIMClassSelect, ETIMClassSelectText, onNoResults, useGeneric }) => {
  const { serieComercialLister, serieSAPLister, serieComercialSuggester, serieComercialSAPSuggester, etimLister, etimSuggester } = useService();

  const intl = useIntl();

  const [wizardState, setWizardState] = useHistoryState("ETIM.Wizard");

  let searchFields = [
    {
      id: "series",
      label: intl.formatMessage({
        id: "app.series",
        defaultMessage: "series",
      }),
      value: "",
      suggester: useGeneric ? serieComercialSuggester : serieComercialSAPSuggester,
    },
    {
      id: "series_id",
      label: intl.formatMessage({
        id: "app.series_code",
        defaultMessage: "Series Code",
      }),
      value: "",
      suggester: useGeneric ? serieComercialSuggester : serieComercialSAPSuggester,
    },
    {
      id: "etim_class",
      label: intl.formatMessage({
        id: "app.etim_class",
        defaultMessage: "ETIM Class",
      }),
      value: "",
      suggester: etimSuggester,
    },
  ];

  const searchHandles = {
    series: {
      lister: useGeneric ? serieComercialLister : serieSAPLister,
      step: "series",
      filter: (value) => ({ serieCommercial: value }),
    },
    series_id: {
      lister: serieSAPLister,
      step: "series",
      filter: (value) => ({ codSerieCommercial: value }),
    },
    etim_class: {
      lister: etimLister,
      step: "series",
      filter: (value) => ({ classETIM: value }),
    },
  };

  const [submittedSearch, setSubmittedSearch] = useState(null);

  async function handleSearchSubmit(search) {
    if (search !== null) {
      let handle = searchHandles[search.id];
      setSubmittedSearch({
        step: handle.step,
        filter: handle.filter(search.value),
      });
    } else {
      setSubmittedSearch(null);
    }
  }

  function renderSmallTableHeader({ column, children }) {
    return (
      <th {...column.getHeaderProps()} style={{ width: "1%" }}>
        {children}
      </th>
    );
  }

  const listers = {
    series: useGeneric ? serieComercialLister : serieSAPLister,
    etim: etimLister,
  };

  return (
    <>
      <Row>
        <Col>
          <MultiSearchPanel fields={searchFields} onSubmit={handleSearchSubmit} isOpen={true} onToggleOpen={() => {}} />
        </Col>
      </Row>
      {submittedSearch && (
        <Row className="mt-3">
          <Col>
            <Card>
              <CardHeader>Results</CardHeader>
              <CardBody className="">
                <SearchWizard
                  search={submittedSearch}
                  onSelect={onSeriesSelect}
                  // initialState={wizardState}
                  onStateChange={setWizardState}
                  steps={[
                    {
                      id: "series",
                      title: intl.formatMessage({ id: "curves_generator.series", defaultMessage: "Series" }),
                      columns: [
                        { id: "icon", TableHeader: renderSmallTableHeader, Cell: () => <i className="fas fa-boxes"></i> },
                        { Header: intl.formatMessage({ id: "curves_generator.series_name", defaultMessage: "Series name" }), accessor: "serieCommercial" },
                        { Header: intl.formatMessage({ id: "app.series_code", defaultMessage: "Series Code" }), accessor: "id" },
                        { Header: intl.formatMessage({ id: "app.etim_class", defaultMessage: "ETIM Class" }), accessor: "classETIMDescription" },
                      ],
                      lister: listers.etim,
                      map: (series) => series,
                      pageSize: 10,
                    },
                  ]}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      )}
    </>
  );
};

export default ProductSearch;
